import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../../i18n';
import { API_HOST } from '../../../config/app-const';
import { setAccessToken } from "../../../mixins/insight/setAccessToken";

const state = {
  standardBreakdowns: {
    isBusy: false,
    data: [],
    error: null
  }
};

const mutations = {
  LOAD_STANDARD_BREAKDOWNS_BUSY: (state, payload) => {
    state.standardBreakdowns.isBusy = payload;
  },
  LOAD_STANDARD_BREAKDOWNS_SUCCESS: (state, payload) => {
    state.standardBreakdowns.data = payload.data;
    state.standardBreakdowns.error = null;
  },
  LOAD_STANDARD_BREAKDOWNS_FAIL: (state, payload) => {
    state.standardBreakdowns.isBusy = false;
    state.standardBreakdowns.data = [];
    state.standardBreakdowns.error = payload;
  }
};

const actions = {
  getStandardBreakdowns: ({ commit, rootState }, { projectId, queryId }) => {
    commit('LOAD_STANDARD_BREAKDOWNS_BUSY', true);

    const config = {
      headers: { 'Authorization': setAccessToken(rootState) }
    };

    return Axios.get(`${API_HOST}/projects/${projectId}/queries/standard_breakdown${queryId ? '?queryId=' + queryId : ''}`, config)
      .then(response => {
          commit('LOAD_STANDARD_BREAKDOWNS_SUCCESS', response.data || [])
          return response.data || [];
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_STANDARD_BREAKDOWNS_FAIL', error)
      })
      .finally(() => {
        commit('LOAD_STANDARD_BREAKDOWNS_BUSY', false);
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};